import React, { useEffect } from 'react';

import {
  Actionsheet as UCLActionSheet,
  ActionsheetProps as UCLActionsheetProps,
  addWithConfig,
} from '@rbilabs/universal-components';

import { CustomEventNames, EventTypes, logRBIEvent } from 'state/amplitude';
import { isWeb } from 'utils/environment';

interface ActionsheetProps extends UCLActionsheetProps {
  onOpenEventMessage: string;
}

// This component is wrapper to register open Action sheet events in the app
export const ActionsheetWrapper = ({ onOpenEventMessage, ...props }: ActionsheetProps) => {
  const hideDragIndicator = isWeb;

  useEffect(() => {
    if (props.isOpen) {
      logRBIEvent({
        name: CustomEventNames.ACTION_SHEET_VIEW,
        type: EventTypes.Other,
        attributes: {
          actionSheetHeader: onOpenEventMessage,
        },
      });
    }
  }, [props.isOpen, onOpenEventMessage]);

  return <UCLActionSheet {...props} hideDragIndicator={hideDragIndicator} />;
};

export const ActionsheetContent = addWithConfig(UCLActionSheet.Content).withConfig({
  // Accounts for extra space when drag indicator is hidden
  _web: {
    marginTop: '$7',
  },
  // @ts-ignore
  _dragIndicator: { width: 16, marginBottom: -12, marginTop: 1 },
});
